export default {
  UPDATE_USER: 'UPDATE_USER',
  USER_LOGIN: 'USER_LOGIN',
  SET_USER_BALANCE: 'SET_USER_BALANCE',
  SET_TERMINAL_USER: 'SET_TERMINAL_USER',
  SET_USER_BONUSES: 'SET_USER_BONUSES',
  GIVE_THE_USER_FREE_BETS: 'GIVE_THE_USER_FREE_BETS',
  SET_USER_SESSION_TOKEN: 'SET_USER_SESSION_TOKEN',
};
